import {
  affiliateReducer,
  enotaryReducer,
  enotarySchedulingReducer,
  httpReducer,
  identityReducer,
  profileReducer,
  profileFeedbackReducer,
  pointservReducer,
  achLoginReducer,
  surveyTypeReducer,
} from '@figure/frontlib-onboarding-redux';
import { optimizeReducer, incentiveReducer } from '@figure/frontlib-growth';
import crossSellOfferReducer from './cross-sell-offer-reducer';
import disclosureReducer from './disclosure-reducer';
import featureDetectionReducer from './feature-detection-reducer';
import leaveSurveyReducer from './leave-survey-reducer';
import offerReducer from './offer-reducer';
import personalLoanReducer from './personal-loan-reducer';
import eligibleStatesReducer from './eligible-states-reducer';
import themeReducer from './theme-reducer';
import smsConsentReducer from './sms-consent-reducer';
import trueworkReducer from './truework-reducer';

const reducers = {
  affiliateReducer,
  httpReducer,
  achLoginReducer,
  crossSellOfferReducer,
  disclosureReducer,
  enotaryReducer,
  enotarySchedulingReducer,
  featureDetectionReducer,
  identityReducer,
  leaveSurveyReducer,
  offerReducer,
  personalLoanReducer,
  profileReducer,
  profileFeedbackReducer,
  pointservReducer,
  eligibleStatesReducer,
  themeReducer,
  incentiveReducer,
  surveyTypeReducer,
  smsConsentReducer,
  optimizeReducer,
  trueworkReducer,
};

export default reducers;
